
<bulb-cover-image
  [imageAsset]="imageAsset"
  [imageDesc]="'Background Image'"
  [attPosition]="attPosition"
  [isImageZoom]="imageZoom && imageEffect === 'ZOOM_OUT'"
  class="cover-image cover-image--{{ imageEffect }}"
></bulb-cover-image>

<div *ngIf="imageAsset" class="bottom-fade"></div>
